// extracted by mini-css-extract-plugin
module.exports = {"pieChart":"chart_pieChart__1Ta3f"};